import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import AdvanceSharePackList from './advance-share-pack-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Advance Share Pack">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Advance Shares</Breadcrumb.Item>
            <Breadcrumb.Item active>Packs</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <AdvanceSharePackList />
    </Panel>
  );
};

export default Page;
